// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  moeUserApiProxyUrl: "https://tim.mutualofenumclaw.com/mx/api",
  portalOneModalV2Url: "https://stgportalone.processonepayments.com/GenericModalV2/PortalOne.js?purejs",
  oneIncModalKey: "08859710-D388-4D87-9121-5D6E3598DA33",
  production: false,
  googleAnalyticsMeasurementId: "G-RCH4YSZQQK",
  msal: {
    clientId: "eee2630c-7408-4402-a78a-4f491516605e",
    authority: "https://moememberlogin.ciamlogin.com/201863d3-7548-4062-87c2-6ce797b3d5ef",
    redirectUri: "https://member.amex-tst.moe-cloud.com/auth",
    postLogoutRedirectUri: "https://member.amex-tst.moe-cloud.com",
    scopes: ["api://d5026aa7-d06d-40ba-a877-c3ea6eb28b8a/access_as_user"],
    protectedResources: {
      apiUrl: "https://tim.mutualofenumclaw.com/mx/api/",
      scopes: ["api://d5026aa7-d06d-40ba-a877-c3ea6eb28b8a/access_as_user"]
    }
  }  
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
 import 'zone.js/dist/zone-error';  // Included with Angular CLI.
